module.exports = __webpack_public_path__ + "static/media/craneroof.1b92077a.gif";